export enum AvailableServices {
    Fulfilment = "TCF",
}

export interface SubscriptionDto {
    serviceId: AvailableServices;
    isActive: boolean;
    isReadOnly: boolean;
}
